module.exports = __webpack_public_path__ + "img/charity_pig.7214d579.svg";